import React from 'react';
import I18n from 'i18n-js';
import AppInstallQRCode from '../../app_install_qr_code';
import { withUserContext, IUserContext } from '@reverbdotcom/commons/src/components/user_context_provider';
import { AppleAppStoreLink, GooglePlayStoreLink } from '../../shared/app_store_links';
import appCallout from '../../../../images/homepage/app-callout.png';

export function DownloadAppCallout(props: IUserContext) {
  return (
    <div className="download-app">
      <div className="download-app__container">
        <div className="download-app__image-container">
          <img
            className="download-app__image"
            src={appCallout}
            alt=""
            aria-hidden="true"
          />
        </div>
        <div className="download-app__content">
          <h3 className="download-app__title">
            {I18n.t('discovery.getTheApp.header')}
          </h3>
          <p className="size-130">
            {I18n.t('discovery.getTheApp.subtitle')}
          </p>
          <div className="d-flex">
            <div className="mr-1">
              <AppleAppStoreLink linkLocation="homepage" userLocale={props.user.locale} />
            </div>
            <GooglePlayStoreLink linkLocation="homepage" userLocale={props.user.locale} />
          </div>
          <div className="mt-1 width-rem-40 tablet-d-none">
            <AppInstallQRCode />
          </div>
        </div>
      </div>
    </div>
  );
}

export default withUserContext(DownloadAppCallout);
